"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GraphQLClient = void 0;
/**
 * A GraphQL client for making requests against GraphQL interface of the service under test.
 */
class GraphQLClient {
    httpClient;
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    /**
     * Execute a query or mutation against the GraphQL interface.
     */
    async query(query, options) {
        const gOptions = options ?? {};
        const path = gOptions.customPath ?? "/graphql";
        const headers = gOptions.httpHeaders ?? [];
        const variables = gOptions.variables ?? {};
        const response = await this.httpClient.request("POST", path, headers, {
            query,
            variables,
        });
        return response.parsedBody;
    }
}
exports.GraphQLClient = GraphQLClient;
//# sourceMappingURL=graphql-client.js.map